import { Action } from 'redux';
import { Orientation, DeviceType, Platform } from 'sofa-reborn-react';

// State
export interface DeviceState {
	deviceType: DeviceType;
	orientation: Orientation;
	platform: Platform;
}

// Actions
export const SET_DEVICE_TYPE = 'SET_DEVICE_TYPE';
export const SET_ORIENTATION = 'SET_ORIENTATION';
export const SET_PLATFORM = 'SET_PLATFORM';

interface SetDeviceTypeAction extends Action {
	type: typeof SET_DEVICE_TYPE;
	value: DeviceType;
}

interface SetOrientationAction extends Action {
	type: typeof SET_ORIENTATION;
	value: Orientation;
}

interface SetPlatformAction extends Action {
	type: typeof SET_PLATFORM;
	value: Platform;
}

export type DeviceStateActions = SetDeviceTypeAction | SetOrientationAction | SetPlatformAction;
